module.exports = __webpack_public_path__ + "static/wherewework_map1@2x-cbdcb2d05a603d866e0db7318a43c11a.png";